import moment from "moment";
import React, { useState, useEffect, useContext, Fragment } from "react";
import UserContext from "../components/TheUser";
import DatePicker from "react-datepicker";
import { Dialog, Transition } from "@headlessui/react";

import "react-datepicker/dist/react-datepicker.css";
import { FormProvider, SubmitHandler, useForm } from "react-hook-form";
import { addUpdateConsultant } from "../api/consultants-api";

import { useSnackbar } from "react-simple-snackbar";

import Currency from "react-currency-formatter";

import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { mapResponseToDTO } from "../api/mapper";
import { nanoid } from "nanoid";
import { AddProject, getAllProjects, getAllProjectsByUuid, deleteProject, updateProject } from "../api/project-api";
import { resetInvoiceOnRateChange, fetchProjectDetails } from "../api/finance-api";
import { Accordion } from "flowbite-react";
import Moment from "react-moment";
import { Md5 } from "ts-md5";
import { COMMERCIAL_PARTNER_IKAT, COMMERCIAL_PARTNER_RT, COMMERCIAL_PARTNER_RT_EXCEPTION, DEDUCTION_TYPE_DOLLARS, DEDUCTION_TYPE_PERCENTAGE, IKAT_DEDUCTION_PERCENTAGE_DEFAULT, RT_DEDUCTION_PERCENTAGE_DEFAULT, commercialPartnerOptions, deductionTypeOptions } from "../constants/common";
const ONGOING_SENTINEL = '9999-12-31';
const OVERTIME_OPTIONS = [
    { value: "Not Applicable", label: "Not Applicable" },
    { value: "Applicable", label: "Applicable" },
];
export default function ProjectDetails(props: { profile: any }) {
    const [startDate, setStartDate] = useState(new Date());
    const [endDate, setEndDate] = useState<Date | null>(null);
    const [projects, setProjects] = useState<any>([]);
    const [projectMaster, setProjectMaster] = useState<any>();
    const [data, setData] = useState<any>([]);
    const [editProjectId, setEditProjectId] = useState<string | null>(null);
    const [editStartDate, setEditStartDate] = useState<Date | null>(null);
    const [editEndDate, setEditEndDate] = useState<Date | null>(null);
    const [editRate, setEditRate] = useState<string>("");
    const [editIkatRate, setEditIkatRate] = useState<string>("");
    const [editRtRate, setEditRtRate] = useState<string>("");
    const [editIkatDedType, setEditIkatDedType] = useState<string>(DEDUCTION_TYPE_PERCENTAGE);
    const [editIkatDedValue, setEditIkatDedValue] = useState<string>("");
    const [editRtDedType, setEditRtDedType] = useState<string>(DEDUCTION_TYPE_PERCENTAGE);
    const [editRtDedValue, setEditRtDedValue] = useState<string>("");
    const [editCommercialPartner, setEditCommercialPartner] = useState<string>(COMMERCIAL_PARTNER_IKAT);
    const [editBillingPeriod, setEditBillingPeriod] = useState<string>("");
    const [editOverTime, setEditOverTime] = useState<string>("Not Applicable");
    const [editOverTimeRate, setEditOverTimeRate] = useState<string>("");
    const [overTimeRateDraft, setOverTimeRateDraft] = useState<string>("");
    const [overTimeModalTarget, setOverTimeModalTarget] = useState<"add" | "edit">("add");
    const [overTimePopupOpen, setOverTimePopupOpen] = useState(false);
    const [overlapError, setOverlapError] = useState<string | null>(null);
    const { user: contextUser } = useContext(UserContext) || {};
    const schema = yup.object({
        // e_regular: yup.number().required("*required"),
    });

    let values: any = {};
    // if (props.profile.unstructured) {
    //     values = JSON.parse(props.profile.unstructured)?.paystubAnnexure;
    //     // console.log(values);
    // }

    const [openSnackbar, closeSnackbar] = useSnackbar();

    // if (props.profile) {
    // }

    const methods = useForm({
        resolver: yupResolver(schema),
        mode: "onChange",
        reValidateMode: "onChange",
        defaultValues: {},
        values,
    });

    const {
        register,
        handleSubmit,
        watch,
        control,
        reset,
        trigger,
        setValue,
        getValues,
        getFieldState,
        formState: { errors },
    } = methods;

    // Helper to check if a date string is the sentinel for ongoing
    const isOngoingDate = (dt: any): boolean => {
        if (!dt) return true;
        const dateStr = moment(dt).format('YYYY-MM-DD');
        return dateStr === ONGOING_SENTINEL;
    };

    // Helper function to check if a project is active based on end_date
    const isProjectActive = (endDate: any): boolean => {
        if (!endDate || isOngoingDate(endDate)) return true; // No end date or ongoing sentinel
        const today = new Date();
        today.setHours(0, 0, 0, 0); // Normalize to start of today
        const projectEndDate = new Date(endDate);
        projectEndDate.setHours(0, 0, 0, 0); // Normalize to start of project end date
        return projectEndDate >= today;
    };

    // Helper function to check if two date ranges overlap
    const doDateRangesOverlap = (start1: Date, end1: Date | null, start2: Date, end2: Date | null): boolean => {
        const effectiveEnd1 = (end1 && !isOngoingDate(end1)) ? end1 : new Date(9999, 11, 31);
        const effectiveEnd2 = (end2 && !isOngoingDate(end2)) ? end2 : new Date(9999, 11, 31);
        return start1 <= effectiveEnd2 && effectiveEnd1 >= start2;
    };

    // Helper function to check if new dates overlap with existing projects
    const checkForOverlappingProjects = (newStartDate: Date, newEndDate: Date | null, excludeProjectId?: string): string | null => {
        for (const project of data) {
            if (excludeProjectId && project.id === excludeProjectId) continue;
            const projectStart = new Date(project.start_dt);
            const projectEnd = (project.end_dt && !isOngoingDate(project.end_dt)) ? new Date(project.end_dt) : null;
            if (doDateRangesOverlap(newStartDate, newEndDate, projectStart, projectEnd)) {
                const endDisplay = projectEnd ? moment(projectEnd).format("YYYY/MM/DD") : "Ongoing";
                return `Date range overlaps with existing project "${project.name}" (${moment(projectStart).format("YYYY/MM/DD")} - ${endDisplay})`;
            }
        }
        return null;
    };

    // Watch for changes in startDate, endDate, or data to update overlapError
    useEffect(() => {
        const error = checkForOverlappingProjects(startDate, endDate);
        setOverlapError(error);
    }, [startDate, endDate, data]);

    useEffect(() => {
        // setStartDate(moment(props.profile.start_dt).toDate());
        // setEndDate(moment(props.profile.end_dt).toDate());

        // if (props.profile) {
        //     props.profile.start_dt = moment(props.profile.start_dt).format("YYYY-MM-DD HH:mm:ss");
        //     props.profile.end_dt = moment(props.profile.end_dt).format("YYYY-MM-DD HH:mm:ss");
        // }
        getAllProjects().then((allProjects: any[]) => {
            setProjects(allProjects);
        });
    }, []);

    useEffect(() => {
        // you can do async server request and fill up form

        getAllProjectsByUuid(props.profile.uuid).then((projects: any) => {
            setData(projects);
        });
    }, [reset]);
    const onEdit = () => {
        let activeProject = data.find((e) => e.active === 1);
        if (activeProject) {
            const project = {
                ...activeProject,
                start_dt: new Date(activeProject.start_dt),
                end_dt: activeProject.end_dt ? new Date(activeProject.end_dt) : null,
            };
            setStartDate(moment(project.start_dt).toDate());
            const hasEndDate = project.end_dt && !isOngoingDate(project.end_dt);
            setEndDate(hasEndDate ? moment(project.end_dt).toDate() : null);
            reset(project);
            setProjectMaster(project.name);
        }
    };

    const onSubmit: SubmitHandler<any> = async (data: any) => {
        if (!projectMaster) {
            openSnackbar("Please select a valid project.");
            return;
        }

        if (!props.profile?.uuid) {
            openSnackbar("Profile UUID is missing.");
            return;
        }

        // Validate that start date is not after end date (skip if no end date)
        if (endDate && startDate > endDate) {
            openSnackbar("Start date cannot be after end date.");
            return;
        }

        // Check for overlapping projects (exclude none, since this is a new mapping)
        const overlapError = checkForOverlappingProjects(startDate, endDate);
        if (overlapError) {
            openSnackbar(overlapError);
            return;
        }

        const profile = mapResponseToDTO<typeof props.profile, typeof data>(data);

        data.start_dt = moment(startDate).format("YYYY-MM-DD HH:mm:ss");
        data.end_dt = endDate ? moment(endDate).format("YYYY-MM-DD HH:mm:ss") : (ONGOING_SENTINEL + ' 00:00:00');

        let currentUser = "";
        try {
            currentUser = contextUser?.name || contextUser?.email || "system";
        } catch (e) {
            currentUser = "system";
        }

        // Only the selected partner's rate is stored, so an IKAT mapping never
        // leaks into the RT report and vice versa.
        const commercialPartner = data.commercial_partner || COMMERCIAL_PARTNER_IKAT;
        const usesIkatRate = commercialPartner === COMMERCIAL_PARTNER_IKAT;
        const usesRtRate = commercialPartner === COMMERCIAL_PARTNER_RT;

        const project = {
            uuid: props.profile.uuid,
            pid: `${projectMaster.pid}`,
            active: 1,
            start_dt: data.start_dt,
            end_dt: data.end_dt,
            billing_period: data.billing_period,
            rate: data.rate,
            over_time: data.over_time === "Applicable" ? 1 : 0,
            over_time_rate: data.over_time === "Applicable" && data.over_time_rate ? data.over_time_rate : null,
            commercial_partner: commercialPartner,
            ikat_rate: usesIkatRate ? data.ikat_rate || null : null,
            rt_rate: usesRtRate ? data.rt_rate || null : null,
            ikat_deduction_type: usesIkatRate ? (data.ikat_deduction_type || DEDUCTION_TYPE_PERCENTAGE) : null,
            ikat_deduction_value: usesIkatRate && data.ikat_deduction_value !== "" && data.ikat_deduction_value != null ? data.ikat_deduction_value : null,
            rt_deduction_type: usesRtRate ? (data.rt_deduction_type || DEDUCTION_TYPE_PERCENTAGE) : null,
            rt_deduction_value: usesRtRate && data.rt_deduction_value !== "" && data.rt_deduction_value != null ? data.rt_deduction_value : null,
            // role: projectMaster.role,
            created_by: currentUser,
            updated_by: currentUser,
        };

        AddProject(project).then((result: any) => {
            openSnackbar(result?.error ? result?.error?.sqlMessage : "Project details updated.");
        });
    };

    const handleEditClick = (item: any) => {
        setEditProjectId(item.id);
        setEditStartDate(item.start_dt ? moment(item.start_dt).toDate() : new Date());
        const hasEndDate = item.end_dt && !isOngoingDate(item.end_dt);
        setEditEndDate(hasEndDate ? moment(item.end_dt).toDate() : null);
        setEditRate(item.rate || "");
        setEditIkatRate(item.ikat_rate || "");
        setEditRtRate(item.rt_rate || "");
        setEditCommercialPartner(item.commercial_partner || COMMERCIAL_PARTNER_IKAT);
        setEditIkatDedType(item.ikat_deduction_type || DEDUCTION_TYPE_PERCENTAGE);
        setEditIkatDedValue(item.ikat_deduction_value != null ? String(item.ikat_deduction_value) : "");
        setEditRtDedType(item.rt_deduction_type || DEDUCTION_TYPE_PERCENTAGE);
        setEditRtDedValue(item.rt_deduction_value != null ? String(item.rt_deduction_value) : "");
        setEditBillingPeriod(item.billing_period || "");
        setEditOverTime(item.over_time ? "Applicable" : "Not Applicable");
        setEditOverTimeRate(item.over_time_rate != null ? String(item.over_time_rate) : "");
    };

    const formatDateOrSentinel = (dt: any): string => {
        if (!dt) return ONGOING_SENTINEL + ' 00:00:00';
        const m = moment(dt);
        return m.isValid() ? m.format('YYYY-MM-DD HH:mm:ss') : (ONGOING_SENTINEL + ' 00:00:00');
    };

    const formatDateShortOrSentinel = (dt: any): string => {
        if (!dt) return ONGOING_SENTINEL;
        const m = moment(dt);
        return m.isValid() ? m.format('YYYY-MM-DD') : ONGOING_SENTINEL;
    };

    // A blank deduction value is persisted as NULL (no deduction configured).
    // Any entered percentage/dollars value is stored as-is.
    const deductionValueToPersist = (type: string, value: string): string => {
        if (value === "" || value === null || value === undefined) {
            return "";
        }
        return String(value);
    };

    const handleSaveEdit = async (item: any) => {
        const oldRate = item.rate != null ? String(item.rate) : "";
        const newRate = editRate != null ? String(editRate) : "";
        const oldIkatRate = item.ikat_rate != null ? String(item.ikat_rate) : "";
        const newIkatRate = editIkatRate != null ? String(editIkatRate) : "";
        const oldRtRate = item.rt_rate != null ? String(item.rt_rate) : "";
        const newRtRate = editRtRate != null ? String(editRtRate) : "";
        const oldIkatDedType = item.ikat_deduction_type || DEDUCTION_TYPE_PERCENTAGE;
        const newIkatDedType = editIkatDedType || DEDUCTION_TYPE_PERCENTAGE;
        const oldIkatDedValue = item.ikat_deduction_value != null ? String(item.ikat_deduction_value) : "";
        const newIkatDedValue = editIkatDedValue != null ? String(editIkatDedValue) : "";
        const oldRtDedType = item.rt_deduction_type || DEDUCTION_TYPE_PERCENTAGE;
        const newRtDedType = editRtDedType || DEDUCTION_TYPE_PERCENTAGE;
        const oldRtDedValue = item.rt_deduction_value != null ? String(item.rt_deduction_value) : "";
        const newRtDedValue = editRtDedValue != null ? String(editRtDedValue) : "";
        const oldCommercialPartner = item.commercial_partner || COMMERCIAL_PARTNER_IKAT;
        const newCommercialPartner = editCommercialPartner || COMMERCIAL_PARTNER_IKAT;
        const oldBillingPeriod = item.billing_period || "";
        const newBillingPeriod = editBillingPeriod || "";
        const oldOverTime = item.over_time ? "Applicable" : "Not Applicable";
        const newOverTime = editOverTime || "Not Applicable";
        const oldOverTimeRate = item.over_time_rate != null ? String(item.over_time_rate) : "";
        const newOverTimeRate = editOverTimeRate != null ? String(editOverTimeRate) : "";
        const overTimeChanged = oldOverTime !== newOverTime || (oldOverTime === "Applicable" && oldOverTimeRate !== newOverTimeRate);

        // Only the selected partner's rate is persisted, so the IKAT and RT
        // reports never pick up each other's mappings.
        const savedIkatRate = newCommercialPartner === COMMERCIAL_PARTNER_IKAT ? newIkatRate : "";
        const savedRtRate = newCommercialPartner === COMMERCIAL_PARTNER_RT ? newRtRate : "";
        const savedIkatDedType = newCommercialPartner === COMMERCIAL_PARTNER_IKAT ? newIkatDedType : "";
        const savedIkatDedValue = newCommercialPartner === COMMERCIAL_PARTNER_IKAT ? deductionValueToPersist(newIkatDedType, newIkatDedValue) : "";
        const savedRtDedType = newCommercialPartner === COMMERCIAL_PARTNER_RT ? newRtDedType : "";
        const savedRtDedValue = newCommercialPartner === COMMERCIAL_PARTNER_RT ? deductionValueToPersist(newRtDedType, newRtDedValue) : "";
        const partnerRateChanged =
            oldIkatRate !== savedIkatRate ||
            oldRtRate !== savedRtRate ||
            oldCommercialPartner !== newCommercialPartner ||
            oldIkatDedType !== savedIkatDedType ||
            oldIkatDedValue !== savedIkatDedValue ||
            oldRtDedType !== savedRtDedType ||
            oldRtDedValue !== savedRtDedValue;

        const oldStartDt = formatDateShortOrSentinel(item.start_dt);
        const newStartDt = formatDateShortOrSentinel(editStartDate);
        const oldEndDt = formatDateShortOrSentinel(item.end_dt);
        const newEndDt = formatDateShortOrSentinel(editEndDate);

        const hasDateChange = oldStartDt !== newStartDt || oldEndDt !== newEndDt;
        const hasOtherChange = oldRate !== newRate || partnerRateChanged || oldBillingPeriod !== newBillingPeriod || overTimeChanged;

        if (!hasDateChange && !hasOtherChange) {
            openSnackbar("No changes detected.");
            return;
        }

        let shouldResetInvoices = false;
        if (oldRate !== newRate || oldBillingPeriod !== newBillingPeriod || overTimeChanged) {
            shouldResetInvoices = true;
        }
        if (shouldResetInvoices) {
            if (!window.confirm("Warning: Saving this rate, billing cycle, or overtime change will reset all invoices for this project, rate, and duration. Are you sure you want to proceed?")) {
                openSnackbar("Change cancelled. No invoices were reset.");
                return;
            }
            const projectRows = await fetchProjectDetails({ uuid: item.uuid, pid: item.pid, rate: oldRate } as any);
            if (!projectRows || !projectRows.length) {
                openSnackbar("Project validation failed: No matching project found.");
                return;
            }
            const projectRow = projectRows[0];
            const rowEnd = projectRow.end_dt ? String(projectRow.end_dt) : ONGOING_SENTINEL + ' 00:00:00';
            const itemEnd = item.end_dt ? String(item.end_dt) : ONGOING_SENTINEL + ' 00:00:00';
            if (
                String(projectRow.start_dt) !== String(item.start_dt) ||
                rowEnd !== itemEnd
            ) {
                openSnackbar("Project validation failed: Start/end date mismatch.");
                return;
            }
            try {
                await resetInvoiceOnRateChange({
                    uuid: item.uuid,
                    pid: item.pid,
                    start_dt: formatDateShortOrSentinel(item.start_dt),
                    end_dt: formatDateShortOrSentinel(item.end_dt),
                });
                const formattedItem = {
                    ...item,
                    rate: newRate,
                    over_time: newOverTime === "Applicable" ? 1 : 0,
                    over_time_rate: newOverTime === "Applicable" && newOverTimeRate ? newOverTimeRate : null,
                    commercial_partner: newCommercialPartner,
                    ikat_rate: savedIkatRate,
                    rt_rate: savedRtRate,
                    ikat_deduction_type: savedIkatDedType,
                    ikat_deduction_value: savedIkatDedValue,
                    rt_deduction_type: savedRtDedType,
                    rt_deduction_value: savedRtDedValue,
                    billing_period: newBillingPeriod,
                    start_dt: formatDateOrSentinel(editStartDate),
                    end_dt: formatDateOrSentinel(editEndDate),
                    pid: item.pid,
                    uuid: item.uuid,
                    active: item.active,
                };
                if (item.created_at) {
                    formattedItem.created_at = moment(item.created_at).format('YYYY-MM-DD HH:mm:ss');
                }
                if (item.updated_at) {
                    formattedItem.updated_at = moment(item.updated_at).format('YYYY-MM-DD HH:mm:ss');
                }
                await updateProject(formattedItem);
                openSnackbar("Invoices reset and project details updated.");
            } catch (e) {
                openSnackbar("Failed to reset invoices or update details. Please check manually.");
            }
        } else {
            if (oldBillingPeriod !== newBillingPeriod || hasDateChange) {
                const formattedItem = {
                    ...item,
                    billing_period: newBillingPeriod,
                    rate: newRate,
                    over_time: newOverTime === "Applicable" ? 1 : 0,
                    over_time_rate: newOverTime === "Applicable" && newOverTimeRate ? newOverTimeRate : null,
                    commercial_partner: newCommercialPartner,
                    ikat_rate: savedIkatRate,
                    rt_rate: savedRtRate,
                    ikat_deduction_type: savedIkatDedType,
                    ikat_deduction_value: savedIkatDedValue,
                    rt_deduction_type: savedRtDedType,
                    rt_deduction_value: savedRtDedValue,
                    start_dt: formatDateOrSentinel(editStartDate),
                    end_dt: formatDateOrSentinel(editEndDate),
                    pid: item.pid,
                    uuid: item.uuid,
                    active: item.active,
                };
                if (item.created_at) {
                    formattedItem.created_at = moment(item.created_at).format('YYYY-MM-DD HH:mm:ss');
                }
                if (item.updated_at) {
                    formattedItem.updated_at = moment(item.updated_at).format('YYYY-MM-DD HH:mm:ss');
                }
                await updateProject(formattedItem);
                openSnackbar(hasDateChange ? "Project dates updated." : "Project billing cycle updated.");
            }
        }
        if (partnerRateChanged && !shouldResetInvoices) {
            const formattedItem = {
                ...item,
                rate: newRate,
                over_time: newOverTime === "Applicable" ? 1 : 0,
                over_time_rate: newOverTime === "Applicable" && newOverTimeRate ? newOverTimeRate : null,
                commercial_partner: newCommercialPartner,
                ikat_rate: savedIkatRate,
                rt_rate: savedRtRate,
                ikat_deduction_type: savedIkatDedType,
                ikat_deduction_value: savedIkatDedValue,
                rt_deduction_type: savedRtDedType,
                rt_deduction_value: savedRtDedValue,
                billing_period: newBillingPeriod,
                start_dt: formatDateOrSentinel(editStartDate),
                end_dt: formatDateOrSentinel(editEndDate),
                pid: item.pid,
                uuid: item.uuid,
                active: item.active,
            };
            if (item.created_at) {
                formattedItem.created_at = moment(item.created_at).format('YYYY-MM-DD HH:mm:ss');
            }
            if (item.updated_at) {
                formattedItem.updated_at = moment(item.updated_at).format('YYYY-MM-DD HH:mm:ss');
            }
            await updateProject(formattedItem);
            openSnackbar(`${newCommercialPartner} rate updated.`);
        }
        setEditProjectId(null);
        getAllProjectsByUuid(props.profile.uuid).then((projects: any) => {
            setData(projects);
        });
    };

    const handleDeleteProject = async (item: any) => {
        if (!window.confirm(`Are you sure you want to delete the project "${item.name}"?`)) {
            return;
        }
        try {
            await deleteProject({ uuid: item.uuid, pid: item.pid, id: item.id });
            openSnackbar("Project deleted successfully.");
            getAllProjectsByUuid(props.profile.uuid).then((projects: any) => {
                setData(projects);
            });
        } catch (error) {
            openSnackbar("Failed to delete project.");
        }
    };

    // Defaults to IKAT so existing mappings keep behaving as before.
    const selectedCommercialPartner = watch("commercial_partner") || COMMERCIAL_PARTNER_IKAT;

    // Resolve the per-hour effective rate for a partner's rate + deduction.
    // Mirrors the SQL in finance-api: percentage -> rate x pct%, dollars -> rate - X.
    // A blank value keeps the legacy default pct, so behaviour stays unchanged.
    const effectiveRate = (rate: any, dedType: any, dedValue: any, defaultPct: number): number => {
        const rateNum = Number(rate) || 0;
        const value = dedValue === "" || dedValue === null || dedValue === undefined ? null : Number(dedValue);
        if (dedType === DEDUCTION_TYPE_DOLLARS) {
            return Math.max(0, rateNum - (value ?? 0));
        }
        return Math.max(0, (rateNum * (value ?? defaultPct)) / 100);
    };

    // Short suffix describing how the partner rate is billed (used on the read-only view).
    const deductionLabel = (dedType: any, dedValue: any, defaultPct: number): string => {
        const value = dedValue === "" || dedValue === null || dedValue === undefined ? null : Number(dedValue);
        if (dedType === DEDUCTION_TYPE_DOLLARS) {
            return value ? `(- $${value}/hr)` : "(no deduction)";
        }
        return value !== null ? `(@ ${value}%)` : `(@ ${defaultPct}% default)`;
    };

    // Live deduction config for the New Project Mapping form.
    const ikatDedType = watch("ikat_deduction_type") || DEDUCTION_TYPE_PERCENTAGE;
    const ikatDedValue = watch("ikat_deduction_value");
    const rtDedType = watch("rt_deduction_type") || DEDUCTION_TYPE_PERCENTAGE;
    const rtDedValue = watch("rt_deduction_value");

    // Open the Over Time rate popup and pre-fill it with the current value.
    const openOverTimeModal = (target: "add" | "edit") => {
        const current = target === "edit" ? editOverTimeRate : getValues("over_time_rate") || "";
        setOverTimeRateDraft(current);
        setOverTimeModalTarget(target);
        setOverTimePopupOpen(true);
    };

    // Commit the rate entered in the popup to the add form or the edit row.
    const confirmOverTimeRate = () => {
        if (overTimeModalTarget === "edit") {
            setEditOverTimeRate(overTimeRateDraft);
        } else {
            setValue("over_time_rate", overTimeRateDraft);
            trigger("over_time_rate");
        }
        setOverTimePopupOpen(false);
    };

    return (
        <>
            <Accordion className="w-full">
                <Accordion.Panel className="mt-4">
                    <Accordion.Title>Projects</Accordion.Title>
                    <Accordion.Content>
                        <div className="pb-16 space-y-6">
                            <div className="px-4 py-5 bg-white shadow sm:rounded-lg sm:p-6">
                                <div className="md:grid md:grid-cols-3 md:gap-6">
                                    <div className=" md:mt-0 md:col-span-2">
                                        <div className="overflow-hidden bg-white sm:rounded-lg">
                                            <ul role="list" className="border-gray-200 divide-y divide-gray-200 ">
                                                {data &&
                                                    data.map((item) => (
                                                        <li key={item.course} className="flex py-4">
                                                            <div className="ml-3">
                                                <p className="text-xl font-bold text-gray-900 ">
                                                    {item.name}
                                                    &nbsp; &nbsp;{item.active === 1 && isProjectActive(item.end_dt) && <span className="bg-green-100 text-green-800 text-xs font-medium me-2 px-2.5 py-0.5 rounded dark:bg-green-900 dark:text-green-300">Active</span>}
                                                </p>                                                                <p className="text-sm font-medium text-gray-900">
                                                                    <span className="text-sm text-gray-500">{item.account}</span>
                                                                </p>

                                                                <p className="text-sm text-gray-500">
                                                                    {editProjectId === item.id ? (
                                                                        <div className="flex flex-col gap-4 p-2 bg-white rounded shadow-md w-full max-w-xs">
                                                                            <div className="flex flex-col gap-1">
                                                                                <label className="text-xs text-gray-500 mb-1">Start Date</label>
                                                                                <DatePicker selected={editStartDate} onChange={(date) => setEditStartDate(date)} dateFormat="yyyy-MM-dd" className="border rounded px-2 py-2 w-full" />
                                                                            </div>
                                                                            <div className="flex flex-col gap-1">
                                                                                <label className="text-xs text-gray-500 mb-1">End Date <span className="text-gray-400 font-normal">(leave empty for ongoing)</span></label>
                                                                                <DatePicker selected={editEndDate} onChange={(date) => setEditEndDate(date)} dateFormat="yyyy-MM-dd" isClearable placeholderText="No end date" className="border rounded px-2 py-2 w-full" />
                                                                            </div>
                                                                        </div>
                                                                    ) : (
                                                                        <>
                                                                            <Moment format="YYYY/MM/DD">{item?.start_dt}</Moment> - {item?.end_dt && !isOngoingDate(item?.end_dt) ? <Moment format="YYYY/MM/DD">{item?.end_dt}</Moment> : <span className="text-green-600 font-medium">Ongoing</span>}
                                                                        </>
                                                                    )}
                                                                </p>

                                                                <p className="text-sm font-medium text-gray-900">
                                                                    <span className="text-sm text-gray-500">
                                                                        {editProjectId === item.id ? (
                                                                            <div className="flex flex-col gap-1 mt-2">
                                                                                <label className="text-xs text-gray-500 mb-1">Billing Period</label>
                                                                                <select
                                                                                    value={editBillingPeriod}
                                                                                    onChange={e => setEditBillingPeriod(e.target.value)}
                                                                                    className="border rounded px-2 py-2 w-full"
                                                                                >
                                                                                    <option value="Weekly">Weekly</option>
                                                                                    <option value="Monthly">Monthly</option>
                                                                                    <option value="Monthly Itemized">Monthly Itemized</option>
                                                                                    <option value="Customized">Customized</option>
                                                                                </select>
                                                                            </div>
                                                                        ) : (
                                                                            <>{item.billing_period} Billing Cycle</>
                                                                        )}
                                                                    </span>
                                                                </p>

                                                                <p className="text-sm font-medium text-gray-900">
                                                                    <span className="text-sm text-gray-500">
                                                                        Over Time :{" "}
                                                                        {editProjectId === item.id ? (
                                                                            <div className="flex flex-col gap-1 mt-2">
                                                                                <label className="text-xs text-gray-500 mb-1">Over Time</label>
                                                                                <select
                                                                                    value={editOverTime}
                                                                                    onChange={(e) => {
                                                                                        setEditOverTime(e.target.value);
                                                                                        if (e.target.value === "Applicable") {
                                                                                            openOverTimeModal("edit");
                                                                                        } else {
                                                                                            setEditOverTimeRate("");
                                                                                        }
                                                                                    }}
                                                                                    className="border rounded px-2 py-2 w-full"
                                                                                >
                                                                                    {OVERTIME_OPTIONS.map((opt) => (
                                                                                        <option key={opt.value} value={opt.value}>
                                                                                            {opt.label}
                                                                                        </option>
                                                                                    ))}
                                                                                </select>
                                                                                {editOverTime === "Applicable" && (
                                                                                    <div className="text-xs text-gray-500">
                                                                                        Over Time Rate: $ {editOverTimeRate || "0"}/hr
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        ) : (
                                                                            <>
                                                                                {item.over_time ? (
                                                                                    <>
                                                                                        Applicable{item.over_time_rate != null ? <> - $ {String(item.over_time_rate)}/hr</> : null}
                                                                                    </>
                                                                                ) : (
                                                                                    <>Not Applicable</>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    </span>
                                                                </p>

                                                                <p className="text-sm font-medium text-gray-900">
                                                                    <span className="text-sm text-gray-500">
                                                                        Rate : 
                                                                        {editProjectId === item.id ? (
                                                                            <div className="flex flex-col gap-1 mt-2">
                                                                                <label className="text-xs text-gray-500 mb-1">Commercial Partner Company</label>
                                                                                <select
                                                                                    value={editCommercialPartner}
                                                                                    onChange={(e) => setEditCommercialPartner(e.target.value)}
                                                                                    className="border rounded px-2 py-2 w-full"
                                                                                >
                                                                                    {commercialPartnerOptions.map((opt) => (
                                                                                        <option key={opt.value} value={opt.value}>
                                                                                            {opt.label}
                                                                                        </option>
                                                                                    ))}
                                                                                </select>
                                                                                <label className="text-xs text-gray-500 mb-1">Rate</label>
                                                                                 <input
                                                                                     type="number"
                                                                                     value={editRate}
                                                                                     onChange={(e) => setEditRate(e.target.value)}
                                                                                     className="border rounded px-2 py-2 w-full"
                                                                                     placeholder="Rate"
                                                                                 />
                                                                                 {editCommercialPartner === COMMERCIAL_PARTNER_IKAT ? (
                                                                                     <>
                                                                                         <label className="text-xs text-gray-500 mb-1 mt-2">IKAT Rate</label>
                                                                                         <input
                                                                                             type="number"
                                                                                             value={editIkatRate}
                                                                                             onChange={(e) => setEditIkatRate(e.target.value)}
                                                                                             className="border rounded px-2 py-2 w-full"
                                                                                         />
                                                                                         <label className="text-xs text-gray-500 mb-1 mt-2">IKAT Deduction</label>
                                                                                         <div className="flex gap-2 mt-1">
                                                                                             <select
value={editIkatDedType}
                                  onChange={(e) => {
                                      setEditIkatDedType(e.target.value);
                                      if (e.target.value === DEDUCTION_TYPE_DOLLARS) setEditIkatDedValue("");
                                  }}
                                                                                                 className="border rounded px-2 py-2 w-full"
                                                                                             >
                                                                                                 {deductionTypeOptions.map((opt) => (
                                                                                                     <option key={opt.value} value={opt.value}>
                                                                                                         {opt.label}
                                                                                                     </option>
                                                                                                 ))}
                                                                                             </select>
                                                                                             <input
                                                                                                 type="number"
                                                                                                 value={editIkatDedValue}
onChange={(e) => setEditIkatDedValue(e.target.value)}
                                 className="border rounded px-2 py-2 w-full"
                                 placeholder={String(IKAT_DEDUCTION_PERCENTAGE_DEFAULT)}
                             />
                                                                                         </div>
                                                                                         <span className="text-xs text-gray-400 mt-1">
                                                                                             {editIkatDedType === DEDUCTION_TYPE_DOLLARS
                                                                                                 ? `IKAT effective rate = ${Number(editIkatRate) || 0} - $${Number(editIkatDedValue) || 0} = ${effectiveRate(editIkatRate, editIkatDedType, editIkatDedValue, IKAT_DEDUCTION_PERCENTAGE_DEFAULT).toFixed(2)}`
                                                                                                 : `IKAT effective rate = ${Number(editIkatRate) || 0} x ${editIkatDedValue === "" ? `${IKAT_DEDUCTION_PERCENTAGE_DEFAULT}% (default)` : `${Number(editIkatDedValue)}%`} = ${effectiveRate(editIkatRate, editIkatDedType, editIkatDedValue, IKAT_DEDUCTION_PERCENTAGE_DEFAULT).toFixed(2)}`}
                                                                                         </span>
                                                                                     </>
                                                                                 ) : editCommercialPartner === COMMERCIAL_PARTNER_RT ? (
                                                                                     <>
                                                                                         <label className="text-xs text-gray-500 mb-1 mt-2">RT Rate</label>
                                                                                         <input
                                                                                             type="number"
                                                                                             value={editRtRate}
                                                                                             onChange={(e) => setEditRtRate(e.target.value)}
                                                                                             className="border rounded px-2 py-2 w-full"
                                                                                         />
                                                                                         <label className="text-xs text-gray-500 mb-1 mt-2">RT Deduction</label>
                                                                                         <div className="flex gap-2 mt-1">
                                                                                             <select
value={editRtDedType}
                                  onChange={(e) => {
                                      setEditRtDedType(e.target.value);
                                      if (e.target.value === DEDUCTION_TYPE_DOLLARS) setEditRtDedValue("");
                                  }}
                                                                                                 className="border rounded px-2 py-2 w-full"
                                                                                             >
                                                                                                 {deductionTypeOptions.map((opt) => (
                                                                                                     <option key={opt.value} value={opt.value}>
                                                                                                         {opt.label}
                                                                                                     </option>
                                                                                                 ))}
                                                                                             </select>
                                                                                             <input
                                                                                                 type="number"
                                                                                                 value={editRtDedValue}
onChange={(e) => setEditRtDedValue(e.target.value)}
                                 className="border rounded px-2 py-2 w-full"
                                 placeholder={String(RT_DEDUCTION_PERCENTAGE_DEFAULT)}
                             />
                                                                                         </div>
                                                                                         <span className="text-xs text-gray-400 mt-1">
                                                                                             {editRtDedType === DEDUCTION_TYPE_DOLLARS
                                                                                                 ? `RT effective rate = ${Number(editRtRate) || 0} - $${Number(editRtDedValue) || 0} = ${effectiveRate(editRtRate, editRtDedType, editRtDedValue, RT_DEDUCTION_PERCENTAGE_DEFAULT).toFixed(2)}`
                                                                                                 : `RT effective rate = ${Number(editRtRate) || 0} x ${editRtDedValue === "" ? `${RT_DEDUCTION_PERCENTAGE_DEFAULT}% (default)` : `${Number(editRtDedValue)}%`} = ${effectiveRate(editRtRate, editRtDedType, editRtDedValue, RT_DEDUCTION_PERCENTAGE_DEFAULT).toFixed(2)}`}
                                                                                         </span>
                                                                                     </>
                                                                                 ) : (
                                                                                     <div className="text-xs text-gray-500 bg-gray-50 border border-gray-200 rounded px-2 py-2 mt-2">
                                                                                         RT exception - reports will use the Project Rate ({editRate || '0'}) above.
                                                                                     </div>
                                                                                 )}
                                                                            </div>
                                                                        ) : (
                                                                            <>
                                                                                {item.rate ? (
                                                                                    <>
                                                                                        <Currency quantity={Number(item.rate)} currency="USD" /> Per Hour
                                                                                    </>
                                                                                ) : item.fixed_payment ? (
                                                                                    <>
                                                                                        <Currency quantity={Number(item.fixed_payment)} currency="USD" /> Per Month
                                                                                    </>
                                                                                ) : (
                                                                                    "-"
                                                                                )}
                                                                             {item.commercial_partner && (
                                                                                 <div className="mt-1 text-xs text-gray-500">
                                                                                     Commercial Partner: {item.commercial_partner}
                                                                                 </div>
                                                                             )}
                                                                             {item.commercial_partner !== COMMERCIAL_PARTNER_RT && item.ikat_rate ? (
                                                                                 <div className="mt-1">
                                                                                     IKAT Rate: <Currency quantity={Number(item.ikat_rate)} currency="USD" /> Per Hour{" "}
                                                                                     <span className="text-xs text-gray-500">
                                                                                         {deductionLabel(item.ikat_deduction_type, item.ikat_deduction_value, IKAT_DEDUCTION_PERCENTAGE_DEFAULT)}
                                                                                     </span>
                                                                                 </div>
                                                                             ) : null}
                                                                             {item.commercial_partner === COMMERCIAL_PARTNER_RT && item.rt_rate ? (
                                                                                 <div className="mt-1">
                                                                                     RT Rate: <Currency quantity={Number(item.rt_rate)} currency="USD" /> Per Hour{" "}
                                                                                     <span className="text-xs text-gray-500">
                                                                                         {deductionLabel(item.rt_deduction_type, item.rt_deduction_value, RT_DEDUCTION_PERCENTAGE_DEFAULT)}
                                                                                     </span>
                                                                                 </div>
                                                                             ) : null}
                                                                            </>
                                                                        )}
                                                                    </span>
                                                                </p>
                                                                {editProjectId === item.id ? (
                                                                    <div className="flex flex-row justify-end gap-2 mt-4">
                                                                        <button
                                                                            className="px-4 py-1 text-sm text-white bg-blue-600 rounded"
                                                                            onClick={() => handleSaveEdit(item)}
                                                                            type="button"
                                                                        >
                                                                            Save
                                                                        </button>
                                                                        <button
                                                                            className="px-4 py-1 text-sm text-gray-700 bg-gray-200 rounded"
                                                                            onClick={() => setEditProjectId(null)}
                                                                            type="button"
                                                                        >
                                                                            Cancel
                                                                        </button>
                                                                    </div>
                                                                ) : (
                                                                    <div className="flex gap-2 mt-2">
                                                                        <button
                                                                            className="px-2 py-1 text-sm text-indigo-600 hover:text-indigo-900"
                                                                            onClick={() => handleEditClick(item)}
                                                                            type="button"
                                                                        >
                                                                            Edit
                                                                        </button>
                                                                        {/* <button
                                                                            className="px-2 py-1 text-sm text-red-600 hover:text-red-900"
                                                                            onClick={() => handleDeleteProject(item)}
                                                                            type="button"
                                                                        >
                                                                            Delete
                                                                        </button> */}
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </li>
                                                    ))}
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>

                <Accordion.Panel>
                    <Accordion.Title>New Project Mapping</Accordion.Title>
                    <Accordion.Content>
                        <FormProvider {...methods}>
                            <form onSubmit={methods.handleSubmit(onSubmit)}>
                                <div className="space-y-6">
                                    <div className="px-4 py-5 bg-white shadow sm:rounded-lg sm:p-6">
                                        <div className="md:grid md:grid-cols-3 md:gap-6">
                                            <div className="md:col-span-1">
                                                <h3 className="text-lg font-medium leading-6 text-gray-900">Project Details</h3>
                                                <p className="mt-1 text-xs text-gray-500">Client, Account & Project etc.</p>
                                            </div>
                                            <div className="mt-5 md:mt-0 md:col-span-2">
                                                <div className="grid grid-cols-4 gap-6">
                                                    <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                                        <label htmlFor="project" className="block text-sm font-medium text-gray-700">
                                                            Project
                                                        </label>
                                                        <select
                                                            {...register("project", {
                                                                required: false,
                                                                onChange: (e) => {
                                                                    const selectedProject = projects.find((p: any) => `${p.pid}` === e.target.value);
                                                                    setProjectMaster(selectedProject);
                                                                },
                                                            })}
                                                                id="project"
                                                                multiple={false}
                                                                size={1}
                                                                name="project"
                                                                className="block w-full px-3 py-2 mt-1 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                                value={projectMaster?.pid || ""}
                                                        >
                                                            <option value={""}>select</option>
                                                            {projects.map((p: any, pIdx: any) => (
                                                                <option value={`${p.pid}`} key={nanoid()}>
                                                                    {p.clientName}-{p.name}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    {/* Vendor Field as Dropdown */}
                                                    <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                                        <label htmlFor="vendor" className="block text-sm font-medium text-gray-700">
                                                            Vendor
                                                        </label>
                                                        <select
                                                            {...register("vendor", { required: false })}
                                                            id="vendor"
                                                            name="vendor"
                                                            className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                            value={projectMaster?.vendor || ""}
                                                            disabled // <-- Make read-only
                                                            // onChange removed since it's read-only
                                                        >
                                                            <option value="">Select Vendor</option>
                                                            {(Array.from(new Set(projects.map((p: any) => p.vendor).filter(Boolean))) as string[]).map((vendor) => (
                                                                <option value={vendor} key={vendor}>
                                                                    {vendor}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                    {/* Address Field */}
                                                    <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                                        <label htmlFor="address" className="block text-sm font-medium text-gray-700">
                                                            Address
                                                        </label>
                                                        <input
                                                            {...register("address", { required: false })}
                                                            type="text"
                                                            name="address"
                                                            id="address"
                                                            autoComplete="address"
                                                            className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                            value={projectMaster?.address || ""}
                                                            disabled // <-- Make read-only
                                                        />
                                                    </div>
                                                    {/* Preferred Vendor Field */}
                                                    <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                                        <label htmlFor="preferred_vendor" className="block text-sm font-medium text-gray-700">
                                                            Preferred Vendor
                                                        </label>
                                                        <input
                                                            type="text"
                                                            name="preferred_vendor"
                                                            id="preferred_vendor"
                                                            className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                            value={projectMaster?.pref_vendor || ""}
                                                            disabled // read-only
                                                            readOnly
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="space-y-6">
                                        <div className="px-4 py-5 bg-white shadow sm:rounded-lg sm:p-6">
                                            <div className="md:grid md:grid-cols-3 md:gap-6">
                                                <div className="md:col-span-1">
                                                    <h3 className="text-lg font-medium leading-6 text-gray-900">Project Duration</h3>
                                                    <p className="mt-1 text-xs text-gray-500">Billing Type, Dates etc.</p>
                                                </div>

                                                <div className="mt-5 md:mt-0 md:col-span-2">
                                                    <div className="grid grid-cols-4 gap-6">
                                                        <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                                            <label htmlFor="region" className="block text-sm font-medium text-gray-700">
                                                                Start Date
                                                            </label>

                                                            <DatePicker
                                                                {...register("start_dt", {
                                                                    required: false,
                                                                })}
                                                                // value={props.profile.start_dt}
                                                                dateFormat="yyyy-MM-dd"
                                                                selected={startDate}
                                                                onChange={(date) => {
                                                                    console.warn(date);
                                                                    setStartDate(date);
                                                                }}
                                                                className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                            />
                                                        </div>

                                                        <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                                            <label htmlFor="region" className="block text-sm font-medium text-gray-700">
                                                                End Date <span className="text-gray-400 font-normal">(leave empty for ongoing)</span>
                                                            </label>

                                                            <DatePicker
                                                                {...register("end_dt", {
                                                                    required: false,
                                                                })}
                                                                // value={props.profile.end_dt}
                                                                dateFormat="yyyy-MM-dd"
                                                                selected={endDate}
                                                                onChange={(date) => {
                                                                    console.warn(date);
                                                                    setEndDate(date);
                                                                }}
                                                                isClearable
                                                                placeholderText="No end date"
                                                                className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                            />
                                                        </div>

                                                        <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                                            <label htmlFor="status" className="block text-sm font-medium text-gray-700">
                                                                Billing Period
                                                            </label>
                                                            <select
                                                                // value={props.profile.billing_period}
                                                                id="billing_period"
                                                                // name="status"
                                                                autoComplete="billing_period"
                                                                defaultValue={""}
                                                                className="block w-full px-3 py-2 mt-1 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                                {...register("billing_period", {
                                                                    required: false,
                                                                    // onChange: (e) => setFil({ ...props.profile.billing_period, employee: e.target.value })
                                                                })}
                                                                onChange={(e) => {
                                                                    props.profile.billing_period = e.target.value;
                                                                }}
                                                            >
                                                                <option value="Weekly">Weekly</option>
                                                                <option value="Monthly">Monthly</option>
                                                                <option value="Monthly Itemized">Monthly Itemized</option>
                                                                <option value="Customized">Customized</option>
                                                            </select>
                                                        </div>

                                                        <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                                            <label htmlFor="over_time" className="block text-sm font-medium text-gray-700">
                                                                Over Time
                                                            </label>
                                                            <select
                                                                id="over_time"
                                                                autoComplete="over_time"
                                                                defaultValue={"Not Applicable"}
                                                                className="block w-full px-3 py-2 mt-1 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
{...register("over_time", {
                                                                    required: false,
                                                                })}
                                                                onChange={(e) => {
                                                                    setValue("over_time", e.target.value);
                                                                    if (e.target.value === "Applicable") {
                                                                        openOverTimeModal("add");
                                                                    } else {
                                                                        setValue("over_time_rate", "");
                                                                    }
                                                                }}
                                                            >
                                                                {OVERTIME_OPTIONS.map((opt) => (
                                                                    <option key={opt.value} value={opt.value}>
                                                                        {opt.label}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                            {watch("over_time") === "Applicable" && (
                                                                <div className="mt-1 text-xs text-gray-500">
                                                                    Over Time Rate: $ {watch("over_time_rate") || "0"}/hr
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="space-y-6">
                                        <div className="px-4 py-5 bg-white shadow sm:rounded-lg sm:p-6">
                                            <div className="md:grid md:grid-cols-3 md:gap-6">
                                                <div className="md:col-span-1">
                                                    <h3 className="text-lg font-medium leading-6 text-gray-900">Project Commercials</h3>
                                                    <p className="mt-1 text-xs text-gray-500">Billing Rate etc.</p>
                                                </div>

                                                <div className="mt-5 md:mt-0 md:col-span-2">
                                                    <div className="grid grid-cols-4 gap-6">
                                                        <div className="col-span-6 sm:col-span-6 lg:col-span-4">
                                                            <label htmlFor="commercial_partner" className="block text-sm font-medium text-gray-700">
                                                                Commercial Partner Company
                                                            </label>
                                                            <select
                                                                id="commercial_partner"
                                                                autoComplete="commercial_partner"
                                                                className="block w-full px-3 py-2 mt-1 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                                {...register("commercial_partner", {
                                                                    required: false,
                                                                })}
                                                            >
                                                                {commercialPartnerOptions.map((opt) => (
                                                                    <option key={opt.value} value={opt.value}>
                                                                        {opt.label}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                                            <label htmlFor="rate" className="block text-sm font-medium text-gray-700">
                                                                Project Rate (per hour)
                                                            </label>
                                                            <input
                                                                {...register("rate", {
                                                                    required: false,
                                                                })}
                                                                // value={props.profile.rate}
                                                                type="text"
                                                                name="rate"
                                                                 id="rate"
                                                                 autoComplete="rate"
                                                                 className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                             />
                                                        </div>
                                                         {selectedCommercialPartner === COMMERCIAL_PARTNER_IKAT ? (
                                                             <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                                                 <label htmlFor="ikat_rate" className="block text-sm font-medium text-gray-700">
                                                                     IKAT Rate (per hour)
                                                                 </label>
                                                                 <input
                                                                     {...register("ikat_rate", {
                                                                         required: false,
                                                                     })}
                                                                     type="text"
                                                                     name="ikat_rate"
                                                                     id="ikat_rate"
                                                                     autoComplete="ikat_rate"
                                                                     className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                                 />
                                                                 <div className="flex gap-2 mt-1">
                                                                     <select
                                                                         {...register("ikat_deduction_type", { required: false })}
                                                                         defaultValue={DEDUCTION_TYPE_PERCENTAGE}
                                                                         id="ikat_deduction_type"
                                                                         name="ikat_deduction_type"
                                                                         className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                                     >
                                                                         {deductionTypeOptions.map((opt) => (
                                                                             <option key={opt.value} value={opt.value}>
                                                                                 {opt.label}
                                                                             </option>
                                                                         ))}
                                                                     </select>
                                                                     <input
                                                                         {...register("ikat_deduction_value", { required: false })}
                                                                         type="text"
                                                                         name="ikat_deduction_value"
id="ikat_deduction_value"
                                         placeholder={String(IKAT_DEDUCTION_PERCENTAGE_DEFAULT)}
                                         className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                                     />
                                                                 </div>
                                                                 <label htmlFor="ikat_deduction_value" className="block text-xs font-medium text-gray-400 mt-1">
                                                                     Deduction (% of rate or $ off per hour)
                                                                 </label>
                                                                 <span className="text-xs text-gray-400">
                                                                     {ikatDedType === DEDUCTION_TYPE_DOLLARS
                                                                         ? `IKAT effective rate = ${Number(watch('ikat_rate')) || 0} - $${Number(ikatDedValue) || 0} = ${effectiveRate(watch('ikat_rate'), ikatDedType, ikatDedValue, IKAT_DEDUCTION_PERCENTAGE_DEFAULT).toFixed(2)}`
                                                                         : `IKAT effective rate = ${Number(watch('ikat_rate')) || 0} x ${ikatDedValue === "" || ikatDedValue == null ? `${IKAT_DEDUCTION_PERCENTAGE_DEFAULT}% (default)` : `${Number(ikatDedValue)}%`} = ${effectiveRate(watch('ikat_rate'), ikatDedType, ikatDedValue, IKAT_DEDUCTION_PERCENTAGE_DEFAULT).toFixed(2)}`}
                                                                 </span>
                                                             </div>
                                                         ) : (
                                                             <div className="col-span-6 sm:col-span-6 lg:col-span-2">
                                                                 <label htmlFor="rt_rate" className="block text-sm font-medium text-gray-700">
                                                                     {selectedCommercialPartner === COMMERCIAL_PARTNER_RT_EXCEPTION ? "RT exception - Normal Project Rate applies" : "RT Rate (per hour)"}
                                                                 </label>
                                                                 {selectedCommercialPartner === COMMERCIAL_PARTNER_RT_EXCEPTION ? (
                                                                     <div className="block w-full mt-1 px-3 py-2 text-sm text-gray-500 bg-gray-50 border border-gray-200 rounded-md">
                                                                         Reports will use the Project Rate ({watch('rate') || '0'}) above.
                                                                     </div>
                                                                 ) : (
                                                                     <>
                                                                         <input
                                                                             {...register("rt_rate", {
                                                                                 required: false,
                                                                             })}
                                                                             type="text"
                                                                             name="rt_rate"
                                                                             id="rt_rate"
                                                                             autoComplete="rt_rate"
                                                                             className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                                         />
                                                                         <div className="flex gap-2 mt-1">
                                                                             <select
                                                                                 {...register("rt_deduction_type", { required: false })}
                                                                                 defaultValue={DEDUCTION_TYPE_PERCENTAGE}
                                                                                 id="rt_deduction_type"
                                                                                 name="rt_deduction_type"
                                                                                 className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                                             >
                                                                                 {deductionTypeOptions.map((opt) => (
                                                                                     <option key={opt.value} value={opt.value}>
                                                                                         {opt.label}
                                                                                     </option>
                                                                                 ))}
                                                                             </select>
                                                                             <input
                                                                                 {...register("rt_deduction_value", { required: false })}
                                                                                 type="text"
                                                                                 name="rt_deduction_value"
id="rt_deduction_value"
                                                 placeholder={String(RT_DEDUCTION_PERCENTAGE_DEFAULT)}
                                                 className="block w-full mt-1 border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                                                             />
                                                                         </div>
                                                                         <label htmlFor="rt_deduction_value" className="block text-xs font-medium text-gray-400 mt-1">
                                                                             Deduction (% of rate or $ off per hour)
                                                                         </label>
                                                                         <span className="text-xs text-gray-400">
                                                                             {rtDedType === DEDUCTION_TYPE_DOLLARS
                                                                                 ? `RT effective rate = ${Number(watch('rt_rate')) || 0} - $${Number(rtDedValue) || 0} = ${effectiveRate(watch('rt_rate'), rtDedType, rtDedValue, RT_DEDUCTION_PERCENTAGE_DEFAULT).toFixed(2)}`
                                                                                 : `RT effective rate = ${Number(watch('rt_rate')) || 0} x ${rtDedValue === "" || rtDedValue == null ? `${RT_DEDUCTION_PERCENTAGE_DEFAULT}% (default)` : `${Number(rtDedValue)}%`} = ${effectiveRate(watch('rt_rate'), rtDedType, rtDedValue, RT_DEDUCTION_PERCENTAGE_DEFAULT).toFixed(2)}`}
                                                                         </span>
                                                                     </>
                                                                 )}
                                                             </div>
                                                         )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="flex justify-end pb-10">
                                        <button type="button" className="px-4 py-2 text-sm font-medium text-gray-700 bg-white border border-gray-300 rounded-md shadow-sm hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                            Cancel
                                        </button>
                                        <button
                                            type="submit"
                                            className="inline-flex justify-center px-4 py-2 ml-3 text-sm font-medium text-white bg-blue-900 border border-transparent rounded-md shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:opacity-50 disabled:cursor-not-allowed"
                                            disabled={!!overlapError}
                                        >
                                            Save
                                        </button>
                                        {overlapError && (
                                            <div className="text-red-600 text-sm mt-2 w-full">{overlapError}</div>
                                        )}
                                    </div>
                                </div>
                            </form>
                        </FormProvider>
                    </Accordion.Content>
                </Accordion.Panel>
            </Accordion>

            <Transition.Root appear show={overTimePopupOpen} as={Fragment}>
                <Dialog as="div" className="relative z-50" onClose={() => setOverTimePopupOpen(false)}>
                    <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="ease-in duration-300" leaveFrom="opacity-100" leaveTo="opacity-0">
                        <div className="fixed inset-0 transition-opacity bg-gray-500 bg-opacity-75" />
                    </Transition.Child>

                    <div className="fixed inset-0 z-10 overflow-y-auto">
                        <form
                            onSubmit={(e) => {
                                e.preventDefault();
                                confirmOverTimeRate();
                            }}
                            className="flex items-center justify-center min-h-full p-4 text-center sm:p-0"
                        >
                            <Transition.Child as={Fragment} enter="ease-out duration-300" enterFrom="opacity-0 scale-95" enterTo="opacity-100 scale-100" leave="ease-in duration-300" leaveFrom="opacity-100 scale-100" leaveTo="opacity-0 scale-95">
                                <Dialog.Panel className="relative overflow-hidden text-left transition-all transform bg-white rounded-lg shadow-xl sm:my-8 sm:w-full sm:max-w-md">
                                    <div className="px-4 pt-5 pb-4 bg-white sm:p-6 sm:pb-4">
                                        <Dialog.Title as="h3" className="text-base font-semibold leading-6 text-gray-900">
                                            Over Time Rate
                                        </Dialog.Title>
                                        <div className="mt-2">
                                            <p className="text-sm text-gray-500">Enter the overtime rate (USD per hour) billed for hours punched beyond 8 in a day.</p>
                                        </div>
                                        <div className="mt-3 sm:col-span-6">
                                            <input type="number" min="0" step="0.01" value={overTimeRateDraft} onChange={(e) => setOverTimeRateDraft(e.target.value)} className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" placeholder="Over Time Rate" />
                                        </div>
                                    </div>
                                    <div className="flex justify-center w-full px-4 py-3 bg-gray-50 sm:flex sm:px-6">
                                        <button type="submit" className="inline-flex justify-center w-full px-3 py-2 text-sm font-semibold text-white bg-blue-600 rounded-md shadow-sm hover:bg-blue-500 sm:ml-3 sm:w-auto">
                                            Save
                                        </button>
                                        <button type="button" onClick={() => setOverTimePopupOpen(false)} className="inline-flex justify-center w-full px-3 py-2 text-sm font-semibold text-white bg-gray-400 rounded-md shadow-sm hover:bg-gray-500 sm:ml-3 sm:w-auto">
                                            Cancel
                                        </button>
                                    </div>
                                </Dialog.Panel>
                            </Transition.Child>
                        </form>
                    </div>
                </Dialog>
            </Transition.Root>
        </>
    );
}
